import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import IndustryProfile from '../views/IndustryProfile'
import IndustryInformation from '../views/IndustryInformation'
import IndustryTrends from '../views/IndustryTrends'
import MemberCenter from '../views/MemberCenter'
import TalentRecruitment from '../views/TalentRecruitment'
import DownloadCenter from '../views/DownloadCenter'
import Search from '../views/Search'
import ContentDetails from '../views/ContentDetails'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/home',
    meta:{
      title:'惠州市电力行业协会'
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta:{
      title:'惠州市电力行业协会'
    }
  },
  {
    path: '/industryprofile',
    name: 'IndustryProfile',
    component: IndustryProfile,
    meta:{
      title:'行协概况'
    }
  },
  {
    path: '/industryinformation',
    name: 'IndustryInformation',
    component: IndustryInformation,
    meta:{
      title:'行业信息'
    }
  },
  {
    path: '/industrytrends',
    name: 'IndustryTrends',
    component: IndustryTrends,
    meta:{
      title:'行协动态'
    }
  },
  {
    path: '/memberCenter',
    name: 'MemberCenter',
    component: MemberCenter,
    meta:{
      title:'会员中心'
    }
  },
  {
    path: '/talentrecruitment',
    name: 'TalentRecruitment',
    component: TalentRecruitment,
    meta:{
      title:'行协展示'
    }
  },
  {
    path: '/downloadcenter',
    name: 'DownloadCenter',
    component: DownloadCenter,
    meta:{
      title:'下载中心'
    }
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta:{
      title:'搜索'
    }
  },
  {
    path: '/contentdetails',
    name: 'ContentDetails',
    component: ContentDetails,
    meta:{
      title:'详情'
    }
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
